(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* PickupBird's cart bar. The app's script mounts its #mapApp bar by
     replacing the #themeExtensionEntryPoint div that its app SECTION renders
     below the whole cart — and that branch runs before the app ever checks
     its custom-container hook (#customPickupBirdAppContainer), so the hook
     alone can't win. Adopting the entry point into the side column first
     makes the app mount the bar there; if the app hydrates before this runs,
     the mounted bar itself is moved (React 18 keeps its listeners on the
     moved root). The observer covers late injection. */
  (function placePickupBar() {
    const slot = document.getElementById('customPickupBirdAppContainer');
    if (!slot) return;
    const adopt = () => {
      const node = document.getElementById('mapApp') || document.getElementById('themeExtensionEntryPoint');
      if (node && !slot.contains(node)) slot.appendChild(node);
      return !!document.getElementById('mapApp');
    };
    if (!adopt()) {
      const mo = new MutationObserver(() => {
        if (adopt()) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* Hungarian law: the GTC and the Privacy Policy must each be expressly
     accepted before payment, on boxes that start empty. Checkout cannot be
     modified on this plan, so the cart holds the gate. The button is disabled
     until both required boxes are ticked; the newsletter box never gates
     anything. `required` on the inputs keeps the gate working with JS off. */
  document.querySelectorAll('[data-cart-consent]').forEach((consent) => {
    const form = consent.closest('[data-cart-form]');
    if (!form) return;
    const required = consent.querySelectorAll('[data-consent-required]');
    const button = form.querySelector('.cart__checkout');
    const error = consent.querySelector('[data-consent-error]');
    if (!required.length || !button) return;

    const satisfied = () => Array.prototype.every.call(required, (b) => b.checked);

    const sync = () => {
      const ok = satisfied();
      button.disabled = !ok;
      /* Clear the message as soon as it stops being true; leaving a stale
         error next to a satisfied form is worse than showing nothing. */
      if (ok && error) error.hidden = true;
    };

    consent.addEventListener('change', (e) => {
      if (e.target.matches('[data-consent-required]')) sync();
    });

    /* A disabled button fires no click, so this only runs when JS failed to
       disable it — and it is the message the shopper needs in that case. */
    form.addEventListener('submit', (e) => {
      if (e.submitter && e.submitter.name === 'checkout' && !satisfied()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (error) error.hidden = false;
        const first = consent.querySelector('[data-consent-required]:not(:checked)');
        if (first) first.focus();
      }
    });

    /* Browsers restore checkbox state on back/reload, so the button must be
       re-synced to what the boxes actually show rather than assumed unticked. */
    sync();
  });

  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    /* PickupBird saves the chosen pickup point on the cart attributes but its
       script cannot prefill the checkout address on this theme, so shoppers
       reached checkout with an empty address and saw no delivery options
       until they typed a postal code. The theme does the carry-over itself:
       on checkout, read the point's address ("1013 Budapest, Pauler utca 3")
       and hand it to checkout as prefill parameters. Anything missing or
       unparseable falls through to the normal submit. */
    form.addEventListener('submit', (e) => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      e.preventDefault();

      /* form.submit() skips the clicked button's name=checkout, which is what
         tells /cart to redirect to checkout, so it is re-added by hand. */
      const fallback = () => {
        const h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'checkout';
        h.value = '';
        form.appendChild(h);
        form.submit();
      };

      /* Record what was accepted, against the order, before leaving the cart.
         The gate above already blocked a submit without consent, so reaching
         here means the required boxes were ticked. Written as cart attributes
         because they survive into the order and are visible in Admin, which
         is what makes the consent provable after the fact. A failure here
         must not strand the shopper: the chain continues either way. */
      const consentAttrs = {};
      const consentBox = form.querySelector('[data-cart-consent]');
      if (consentBox) {
        const stamp = new Date().toISOString();
        consentAttrs['Terms accepted'] = stamp;
        consentAttrs['Privacy accepted'] = stamp;
        const news = consentBox.querySelector('[data-consent-newsletter]');
        consentAttrs['Newsletter opt-in'] = news && news.checked ? 'yes' : 'no';
      }

      const recordConsent = Object.keys(consentAttrs).length
        ? fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: consentAttrs }),
          }).catch(() => {})
        : Promise.resolve();

      recordConsent
        .then(() => fetch('/cart.js', { headers: { Accept: 'application/json' } }))
        .then((r) => r.json())
        .then((cart) => {
          const attrs = cart.attributes || {};
          const addr = attrs['Shop address'];
          const m = typeof addr === 'string' && addr.match(/^(\d{4})\s+([^,]+),\s*(.+)$/);
          const q = new URLSearchParams();
          if (m) {
            q.set('checkout[shipping_address][zip]', m[1]);
            q.set('checkout[shipping_address][city]', m[2].trim());
            q.set('checkout[shipping_address][address1]', m[3].trim());
            q.set('checkout[shipping_address][country]', 'Hungary');
          } else {
            /* No pickup point chosen. Checkout remembers the address from an
               abandoned visit, so a point picked and later deleted would still
               replay its address here. Sending the fields empty overwrites
               that leftover state instead of trusting it. */
            q.set('checkout[shipping_address][zip]', '');
            q.set('checkout[shipping_address][city]', '');
            q.set('checkout[shipping_address][address1]', '');
          }
          window.location.href = '/checkout?' + q.toString();
        })
        .catch(fallback);
    });

    form.querySelectorAll('[data-qty]').forEach((wrap) => {
      const input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      const max = parseInt(wrap.getAttribute('data-max'), 10) || 0;
      const error = wrap.parentElement.querySelector('[data-qty-error]');
      const submit = () => { form.submit(); };
      const startValue = parseInt(input.value, 10) || 0;

      /* Cap a requested quantity at the available stock. Shopify would cap it
         server-side anyway, but silently — the shopper only found out at
         checkout. Surfacing it here is the whole point. */
      const clampToStock = (v) => {
        if (max > 0 && v > max) {
          if (error) error.hidden = false;
          return max;
        }
        if (error) error.hidden = true;
        return v;
      };

      wrap.querySelector('[data-qty-dec]').addEventListener('click', () => {
        const v = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = v;
        if (error) error.hidden = true;
        submit();
      });
      wrap.querySelector('[data-qty-inc]').addEventListener('click', () => {
        const v = clampToStock((parseInt(input.value, 10) || 0) + 1);
        input.value = v;
        /* Already at the cap: keep the error on screen instead of reloading
           the page into the same state. */
        if (v !== startValue) submit();
      });
      input.addEventListener('change', () => {
        let v = parseInt(input.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        v = clampToStock(v);
        input.value = v;
        if (v !== startValue) submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-tiles').forEach((root) => {
    const modal = root.querySelector('[data-coming-soon-modal]');
    if (!modal) return;
    const titleEl = modal.querySelector('[data-coming-soon-title]');
    const defaultTitle = titleEl ? titleEl.textContent : '';

    root.querySelectorAll('[data-coming-soon-label]').forEach((tile) => {
      tile.addEventListener('click', () => {
        const label = tile.getAttribute('data-coming-soon-label');
        if (titleEl) titleEl.textContent = label || defaultTitle;
        if (typeof modal.showModal === 'function') {
          modal.showModal();
        }
      });
    });

    const close = modal.querySelector('[data-coming-soon-close]');
    if (close) close.addEventListener('click', () => modal.close());
    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-mystery"]) return;
  try {
    
  document.querySelectorAll('[data-filter-toggle]').forEach((btn) => {
    const section = btn.closest('.cm');
    const sidebar = section ? section.querySelector('[data-filter-sidebar]') : null;
    if (!sidebar) return;
    btn.addEventListener('click', () => {
      const open = sidebar.hasAttribute('data-open');
      if (open) { sidebar.removeAttribute('data-open'); document.documentElement.style.overflow = ''; }
      else { sidebar.setAttribute('data-open', ''); document.documentElement.style.overflow = 'hidden'; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-filter-toggle]').forEach((btn) => {
    const section = btn.closest('.collection');
    const sidebar = section ? section.querySelector('[data-filter-sidebar]') : null;
    if (!sidebar) return;
    btn.addEventListener('click', () => {
      const open = sidebar.hasAttribute('data-open');
      if (open) { sidebar.removeAttribute('data-open'); document.documentElement.style.overflow = ''; }
      else { sidebar.setAttribute('data-open', ''); document.documentElement.style.overflow = 'hidden'; }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header]').forEach((header) => {
    const drawer = header.querySelector('[data-mobile-drawer]');
    const openBtn = header.querySelector('[data-menu-toggle]');
    const closeBtn = header.querySelector('[data-menu-close]');
    if (!drawer) return;
    const open = () => { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; };
    const close = () => { drawer.hidden = true; document.documentElement.style.overflow = ''; };
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      close();
      header.querySelectorAll('[data-dropdown][data-open]').forEach((o) => {
        o.removeAttribute('data-open');
        const t = o.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
    header.querySelectorAll('[data-dropdown]').forEach((item) => {
      const toggle = item.querySelector('[data-dropdown-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        // Hover alone can show the panel without setting data-open, so treat a
        // visible panel as open too, otherwise the first click is a no-op.
        const panel = item.querySelector('[data-dropdown-panel]');
        const isOpen =
          item.hasAttribute('data-open') ||
          (panel && getComputedStyle(panel).visibility === 'visible');
        header.querySelectorAll('[data-dropdown][data-open]').forEach((o) => {
          o.removeAttribute('data-open');
          const t = o.querySelector('[data-dropdown-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (isOpen) {
          // Suppress the hover rule until the pointer leaves, so it stays shut.
          item.setAttribute('data-dismissed', '');
        } else {
          item.removeAttribute('data-dismissed');
          item.setAttribute('data-open', '');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      item.addEventListener('mouseleave', () => item.removeAttribute('data-dismissed'));
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-dropdown]')) return;
      header.querySelectorAll('[data-dropdown][data-open]').forEach((o) => {
        o.removeAttribute('data-open');
        const t = o.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Hero video sound. Autoplay stays muted because browsers refuse to autoplay
     audio; this button is how the visitor opts in. */
  document.querySelectorAll('[data-hero-sound]').forEach((btn) => {
    const art = btn.closest('.hero__art');
    const video = art && art.querySelector('.hero__video');
    if (!video) {
      btn.remove();
      return;
    }

    btn.addEventListener('click', () => {
      const turningOn = video.muted;
      video.muted = !turningOn;
      // Unmuting can require a play() call, and it returns a rejected promise
      // if the browser still refuses — revert rather than show a false state.
      if (turningOn) {
        const played = video.play();
        if (played && typeof played.catch === 'function') {
          played.catch(() => {
            video.muted = true;
            btn.setAttribute('aria-pressed', 'false');
            btn.setAttribute('aria-label', btn.getAttribute('data-label-unmute'));
          });
        }
      }
      btn.setAttribute('aria-pressed', String(turningOn));
      btn.setAttribute(
        'aria-label',
        btn.getAttribute(turningOn ? 'data-label-mute' : 'data-label-unmute')
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    const slides = gallery.querySelectorAll('[data-slide]');
    const media = gallery.querySelector('.pdp__main-media');
    let current = 0;

    const goTo = (i) => {
      const n = slides.length;
      if (!n) return;
      current = ((i % n) + n) % n;
      slides.forEach((s) => s.classList.toggle('pdp__main-slide--active', Number(s.getAttribute('data-slide')) === current));
      thumbs.forEach((t) => t.classList.toggle('pdp__thumb--active', Number(t.getAttribute('data-thumb')) === current));
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.getAttribute('data-thumb'))));
    });

    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));

    if (media && slides.length > 1) {
      media.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      });

      let startX = null;
      media.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        goTo(dx > 0 ? current - 1 : current + 1);
      }, { passive: true });
    }
  });
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('[data-qty-input]');
    const form = wrap.closest('form');
    const error = form ? form.querySelector('[data-qty-error]') : null;
    const getMax = () => parseInt(wrap.getAttribute('data-max'), 10) || 0;

    const showError = (max) => {
      if (!error) return;
      error.textContent = (error.getAttribute('data-label') || '').replace('__COUNT__', max);
      error.hidden = false;
    };
    const hideError = () => { if (error) error.hidden = true; };

    /* Never let the field hold more than the tracked stock — the shopper
       should hit the limit here, not discover it at checkout. */
    const clamp = (v) => {
      if (isNaN(v) || v < 1) v = 1;
      const max = getMax();
      if (max > 0 && v > max) {
        showError(max);
        return max;
      }
      hideError();
      return v;
    };

    wrap.querySelector('[data-qty-dec]').addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      hideError();
    });
    wrap.querySelector('[data-qty-inc]').addEventListener('click', () => {
      input.value = clamp((parseInt(input.value, 10) || 1) + 1);
    });
    input.addEventListener('change', () => { input.value = clamp(parseInt(input.value, 10)); });
  });

  /* Variant switch: the stock cap and the "N in stock" badge follow the
     selected variant. */
  document.querySelectorAll('.pdp__variant-select').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const max = parseInt(option.getAttribute('data-max'), 10) || 0;
      const wrap = select.closest('form').querySelector('[data-qty]');
      if (wrap) {
        wrap.setAttribute('data-max', String(max));
        const input = wrap.querySelector('[data-qty-input]');
        const v = parseInt(input.value, 10) || 1;
        if (max > 0 && v > max) input.value = max;
      }
      const badge = document.querySelector('[data-stock-badge]');
      if (badge) {
        badge.textContent = max > 0
          ? (badge.getAttribute('data-label-count') || '').replace('__COUNT__', max)
          : badge.getAttribute('data-label-in-stock');
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-rows"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.story').forEach((story) => {
    const rows = story.querySelectorAll('[data-story-row]');
    if (!rows.length) return;
    /* story--js is already on the element from Liquid. If IntersectionObserver
       is missing, take it OFF so the hidden state is released and everything
       shows — otherwise the content would stay invisible forever. */
    if (!('IntersectionObserver' in window)) {
      story.classList.remove('story--js');
      return;
    }
    // R2: drift the brand-colour washes in once the page has painted. rAF
    // twice so the starting transform is committed before the class flips,
    // otherwise the browser collapses both states into no transition.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => story.classList.add('story--lit'));
    });
    /* threshold 0 + a bottom rootMargin, NOT a percentage threshold. These
       rows are frequently taller than the viewport once the disc is stacked
       above the text, and a row that can never show 18% of itself either
       fires late - after the reader has already scrolled past the animation -
       or never fires at all. Triggering as soon as any part crosses 120px
       above the bottom edge means the roll starts while the row is entering,
       which is when it can actually be seen. */
    /* Rows already on screen at load fire together in the observer's first
       callback, so without a stagger the first two discs roll simultaneously
       while the reader is still at the top of the page - which looked like
       "no animation" on the rows that matter most. Each row that is already
       visible waits a little longer than the one above it; rows scrolled to
       later start immediately, since arriving in view is its own cue. */
    let initialPass = true;
    let staggerIndex = 0;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        /* 450ms head start on the first row so the roll begins after the
           page has painted and settled, rather than during load when it is
           easy to miss. */
        const delay = initialPass ? 450 + staggerIndex++ * 900 : 0;
        const target = entry.target;
        setTimeout(() => target.classList.add('story__row--in'), delay);
        io.unobserve(target);
      });
      /* Everything visible at load is delivered in that first callback; from
         here on entries are genuine scroll arrivals. */
      initialPass = false;
    }, { threshold: 0, rootMargin: '0px 0px -120px 0px' });
    rows.forEach((row) => io.observe(row));
  });

  /* R5: swap the dice emoji for the logo mark. The copy lives in
     templates/page.about.json, which is .shopifyignore'd and cannot be fixed by
     a push, so it is done here on rendered text. Doing it in Liquid risked the
     richtext field being HTML-escaped by the filter; walking text nodes cannot
     escape or re-parse the surrounding markup. No-op once the emoji is gone. */
  (function swapDiceForLogo() {
    const mark = document.querySelector('[data-story-logo-template]');
    if (!mark) return;
    /* Built from the code point rather than pasted inline: the die is a
       surrogate pair, and a literal can arrive mangled through the asset
       pipeline and then match nothing. */
    const DIE = String.fromCodePoint(0x1F3B2);
    document.querySelectorAll('.story__body').forEach((body) => {
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      const hits = [];
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue.indexOf(DIE) !== -1) hits.push(walker.currentNode);
      }
      hits.forEach((node) => {
        const parts = node.nodeValue.split(DIE);
        const frag = document.createDocumentFragment();
        parts.forEach((part, i) => {
          if (i > 0) frag.appendChild(mark.content.cloneNode(true));
          if (part) frag.appendChild(document.createTextNode(part));
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
  })();

  document.querySelectorAll('[data-story-body][data-collapsible]').forEach((body) => {
    const btn = body.parentElement.querySelector('[data-story-more]');
    if (!btn) return;
    const label = btn.querySelector('[data-story-more-label]');
    const more = label ? label.textContent : '';
    const less = btn.getAttribute('data-label-less') || 'See less';
    // Only clamp when the copy is genuinely taller than the limit.
    const limit = parseInt(getComputedStyle(body).getPropertyValue('--story-clamp'), 10) || 260;
    if (body.scrollHeight <= limit + 24) return;
    body.classList.add('story__body--clamped');
    /* Force the clamped layout to commit before arming transitions, so the
       initial clamp doesn't itself play as a collapse animation on load. */
    body.getBoundingClientRect();
    body.classList.add('story__body--animate');
    btn.hidden = false;
    btn.setAttribute('aria-expanded', 'false');
    if (body.id) btn.setAttribute('aria-controls', body.id);
    let releaseTimer;
    const release = () => {
      body.style.maxHeight = '';
      body.removeEventListener('transitionend', onEnd);
      clearTimeout(releaseTimer);
    };
    const onEnd = (event) => {
      if (event.target === body && event.propertyName === 'max-height') release();
    };
    btn.addEventListener('click', () => {
      const open = body.classList.contains('story__body--clamped');
      if (open) {
        /* max-height can't animate to `none`: pin the real height as the
           target, then release it once the transition lands (timer covers
           reduced-motion, where no transitionend ever fires). */
        body.style.maxHeight = body.scrollHeight + 'px';
        body.classList.remove('story__body--clamped');
        body.addEventListener('transitionend', onEnd);
        releaseTimer = setTimeout(release, 650);
      } else {
        /* Pin the current height so there is a pixel value to animate FROM,
           commit it, then let the class's clamp take over as the target. */
        release();
        body.style.maxHeight = body.scrollHeight + 'px';
        body.getBoundingClientRect();
        body.classList.add('story__body--clamped');
        body.style.maxHeight = '';
      }
      btn.setAttribute('aria-expanded', String(open));
      if (label) label.textContent = open ? less : more;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-withdrawal]');
    if (!root) return;

    // Success page: if the confirmation request failed on the previous view,
    // say so plainly rather than letting the customer assume it is on its way.
    var warn = root.querySelector('[data-confirmation-warning]');
    if (warn) {
      try {
        if (sessionStorage.getItem('bgm-elallas-confirmation') === 'failed') {
          warn.hidden = false;
        }
        sessionStorage.removeItem('bgm-elallas-confirmation');
      } catch (e) { /* storage unavailable; the success text already advises a 24 hour wait */ }
    }
    var form = root.querySelector('form');
    var stepForm = root.querySelector('[data-step-form]');
    var stepReview = root.querySelector('[data-step-review]');
    if (!form || !stepForm || !stepReview) return; // success state renders neither step

    var widgetId = null;
    var turnstileToken = '';

    // The Turnstile script is async/defer, so window.turnstile may not exist
    // yet when the customer reaches the review step. The previous code rendered
    // the widget only if it happened to be loaded by then and never retried, so
    // on a slow connection no widget appeared, no token was ever produced, and
    // the worker rejected the submission with 403 -- silently, because the page
    // navigates away before the response arrives. Poll briefly instead, and
    // capture the token in a callback rather than assuming getResponse() is
    // ready at click time.
    var verifyStatus = root.querySelector('[data-verify-status]');

    function setVerifyStatus(message, isError) {
      if (!verifyStatus) return;
      verifyStatus.textContent = message || '';
      verifyStatus.hidden = !message;
      verifyStatus.classList.toggle('withdrawal__verify--error', !!isError);
    }

    function renderTurnstile() {
      var sitekey = root.getAttribute('data-turnstile-sitekey');
      if (!sitekey || widgetId !== null) return;
      if (!window.turnstile) {
        // Script not in yet -- try again shortly, up to ~10s.
        renderTurnstile.tries = (renderTurnstile.tries || 0) + 1;
        if (renderTurnstile.tries < 50) {
          setTimeout(renderTurnstile, 200);
        } else {
          // Script never arrived (blocked, offline, corporate proxy). Say so
          // rather than letting the customer submit into a certain failure.
          setVerifyStatus(root.getAttribute('data-verify-failed'), true);
        }
        return;
      }
      widgetId = window.turnstile.render(root.querySelector('[data-turnstile]'), {
        sitekey: sitekey,
        callback: function (token) { turnstileToken = token || ''; setVerifyStatus(''); },
        'expired-callback': function () {
          turnstileToken = '';
          window.turnstile.reset(widgetId);
        },
        'error-callback': function () {
          turnstileToken = '';
          setVerifyStatus(root.getAttribute('data-verify-failed'), true);
        }
      });
    }

    // Start as soon as the page is interactive rather than waiting for the
    // click, so the challenge has already solved by the time it is needed.
    renderTurnstile();

    function fieldValue(name) {
      var el = form.elements[name];
      return el && el.value ? el.value.trim() : '';
    }

    // Neither date can be in the future, and delivery cannot precede the
    // order. Set in JS, not Liquid: a Liquid "now" is frozen in the page cache.
    var orderDate = root.querySelector('[data-date-order]');
    var deliveryDate = root.querySelector('[data-date-delivery]');
    var today = new Date();
    var todayIso = today.getFullYear() + '-' +
      ('0' + (today.getMonth() + 1)).slice(-2) + '-' +
      ('0' + today.getDate()).slice(-2);
    if (orderDate) orderDate.max = todayIso;
    if (deliveryDate) deliveryDate.max = todayIso;

    function checkDateOrder() {
      if (!orderDate || !deliveryDate) return;
      // ISO yyyy-mm-dd strings compare correctly as plain strings.
      var bad = orderDate.value && deliveryDate.value && deliveryDate.value < orderDate.value;
      deliveryDate.setCustomValidity(bad ? root.getAttribute('data-delivery-before-order') : '');
    }
    if (orderDate) orderDate.addEventListener('change', checkDateOrder);
    if (deliveryDate) deliveryDate.addEventListener('change', checkDateOrder);

    // Whole order vs. named products. The rows are inputs without a name;
    // syncProducts() joins them into the hidden contact[Products] field.
    var MAX_ROWS = 20;
    var productsValue = root.querySelector('[data-products-value]');
    var productsBox = root.querySelector('[data-products]');
    var rowsBox = root.querySelector('[data-product-rows]');
    var rowTemplate = root.querySelector('[data-product-row-template]');
    var addBtn = root.querySelector('[data-add-product]');
    var scopeWhole = root.querySelector('[data-scope-whole]');
    var scopeSome = root.querySelector('[data-scope-some]');
    var wholeLabel = root.getAttribute('data-whole-order') || '';
    var rowCounter = 0;

    function productRows() {
      return rowsBox ? rowsBox.querySelectorAll('.withdrawal__product-row') : [];
    }

    function renumberRows() {
      var rows = productRows();
      var labelTpl = root.getAttribute('data-product-label') || '';
      for (var i = 0; i < rows.length; i++) {
        rows[i].querySelector('[data-row-label]').textContent = labelTpl.replace('__N__', i + 1);
        // The first row cannot be removed: "some products" needs at least one.
        rows[i].querySelector('[data-remove-product]').hidden = rows.length === 1;
      }
      if (addBtn) addBtn.hidden = rows.length >= MAX_ROWS;
    }

    function addRow(value) {
      if (!rowTemplate || !rowsBox || productRows().length >= MAX_ROWS) return null;
      var node = rowTemplate.content.firstElementChild.cloneNode(true);
      var input = node.querySelector('[data-product-input]');
      var id = 'withdrawal-product-' + (++rowCounter);
      input.id = id;
      node.querySelector('[data-row-label]').setAttribute('for', id);
      if (value) input.value = value;
      node.querySelector('[data-remove-product]').addEventListener('click', function () {
        node.parentNode.removeChild(node);
        renumberRows();
      });
      rowsBox.appendChild(node);
      renumberRows();
      return input;
    }

    function applyScope() {
      var some = scopeSome && scopeSome.checked;
      if (productsBox) productsBox.hidden = !some;
      if (some && !productRows().length) addRow('');
      var inputs = rowsBox ? rowsBox.querySelectorAll('[data-product-input]') : [];
      // Only the first row is required; extra empty rows are simply skipped.
      for (var i = 0; i < inputs.length; i++) inputs[i].required = some && i === 0;
    }

    function syncProducts() {
      if (!productsValue) return;
      if (scopeWhole && scopeWhole.checked) {
        productsValue.value = wholeLabel;
        return;
      }
      var names = [];
      var inputs = rowsBox ? rowsBox.querySelectorAll('[data-product-input]') : [];
      for (var i = 0; i < inputs.length; i++) {
        var v = inputs[i].value.trim();
        if (v) names.push(v);
      }
      productsValue.value = scopeSome && scopeSome.checked ? names.join('; ') : '';
    }

    // Re-render after a server-side form error: restore the earlier choice.
    if (productsValue && productsValue.value) {
      if (productsValue.value === wholeLabel) {
        if (scopeWhole) scopeWhole.checked = true;
      } else if (scopeSome) {
        scopeSome.checked = true;
        productsValue.value.split(';').forEach(function (name) {
          if (name.trim()) addRow(name.trim());
        });
      }
    }
    if (scopeWhole) scopeWhole.addEventListener('change', applyScope);
    if (scopeSome) scopeSome.addEventListener('change', function () {
      applyScope();
      var first = rowsBox && rowsBox.querySelector('[data-product-input]');
      if (first && !first.value) first.focus();
    });
    if (addBtn) addBtn.addEventListener('click', function () {
      var input = addRow('');
      applyScope();
      if (input) input.focus();
    });
    applyScope();

    root.querySelector('[data-continue]').addEventListener('click', function () {
      checkDateOrder();
      syncProducts();
      if (!form.reportValidity()) return;
      var rows = root.querySelectorAll('[data-review-value]');
      for (var i = 0; i < rows.length; i++) {
        var v = fieldValue(rows[i].getAttribute('data-review-value'));
        rows[i].textContent = v || '—';
      }
      stepForm.hidden = true;
      stepReview.hidden = false;
      renderTurnstile();
      if (!turnstileToken) setVerifyStatus(root.getAttribute('data-verify-wait'));
    });

    root.querySelector('[data-back]').addEventListener('click', function () {
      stepReview.hidden = true;
      stepForm.hidden = false;
    });

    var submitting = false;
    form.addEventListener('submit', function () {
      // A second submit event (Shopify's spam check re-submitting the form
      // after it runs) must reach the server, but must not send a second
      // confirmation email.
      if (submitting) return;
      submitting = true;
      var confirmBtn = root.querySelector('[data-confirm]');
      var backBtn = root.querySelector('[data-back]');
      if (confirmBtn) {
        // Not .disabled: Shopify's contact-form spam check re-submits through
        // the original submit button, and a disabled button silently cancels
        // that, leaving the page stuck on "Sending..." with no declaration
        // posted to the inbox (2026-09-29). is-loading blocks clicks in CSS.
        confirmBtn.setAttribute('aria-disabled', 'true');
        confirmBtn.classList.add('is-loading');
        confirmBtn.textContent = confirmBtn.getAttribute('data-sending-label') || confirmBtn.textContent;
      }
      if (backBtn) backBtn.disabled = true;
      // Shared reference id: rides the native form to the store inbox AND the
      // beacon to the confirmation email, so one code identifies a submission.
      // 12 crypto-random chars from a 31-letter alphabet = UUID-grade
      // uniqueness while staying readable over the phone (no I/L/O/0/1).
      // The worker's validator caps submissionId at 40 chars of [A-Z0-9-];
      // this format is 30.
      var now = new Date();
      var ymd = String(now.getFullYear()) +
        ('0' + (now.getMonth() + 1)).slice(-2) +
        ('0' + now.getDate()).slice(-2);
      var rand = '';
      var chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
      var r;
      if (window.crypto && window.crypto.getRandomValues) {
        var buf = new Uint32Array(12);
        window.crypto.getRandomValues(buf);
        for (r = 0; r < 12; r++) rand += chars.charAt(buf[r] % chars.length);
      } else {
        for (r = 0; r < 12; r++) rand += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      var submissionId = 'ELALLAS-' + ymd + '-' + rand;
      var idField = root.querySelector('[data-submission-id]');
      if (idField) idField.value = submissionId;
      var url = root.getAttribute('data-worker-url');
      if (!url) return; // native submit proceeds regardless
      var payload = JSON.stringify({
        name: fieldValue('contact[name]'),
        email: fieldValue('contact[email]'),
        orderNumber: fieldValue('contact[Order number]'),
        orderDate: fieldValue('contact[Order date]'),
        deliveryDate: fieldValue('contact[Delivery date]'),
        products: fieldValue('contact[Products]'),
        note: fieldValue('contact[Note]'),
        submissionId: submissionId,
        locale: root.getAttribute('data-locale') || 'en',
        turnstileToken: turnstileToken || ((window.turnstile && widgetId !== null) ? (window.turnstile.getResponse(widgetId) || '') : '')
      });
      // Previously this fired sendBeacon and navigated away without ever
      // reading the response, so a rejected request was invisible: the customer
      // saw the success page and simply never received their confirmation.
      // keepalive lets the request outlive the navigation, and the result is
      // stashed in sessionStorage so the success page can warn them.
      // The declaration itself is unaffected either way, since it travels on
      // the native contact form.
      try {
        sessionStorage.removeItem('bgm-elallas-confirmation');
      } catch (e) { /* private mode; the 24 hour note in the success text covers it */ }

      try {
        fetch(url, { method: 'POST', body: payload, keepalive: true })
          .then(function (res) {
            if (!res.ok) throw new Error('rejected');
          })
          .catch(function () {
            try { sessionStorage.setItem('bgm-elallas-confirmation', 'failed'); } catch (e) {}
          });
      } catch (e) {
        try { sessionStorage.setItem('bgm-elallas-confirmation', 'failed'); } catch (e2) {}
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
